export const MAX_ASSETS_LOGGED_IN = 1000;
export const MAX_ASSETS_GUEST = 50;
